<template>
  <div class="earn">
    <h5 style="font-weight: bold;">โอน Coin ให้ลูกค้า</h5>
    <div class="row mt-4">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4">
        <div>
          <header style="font-weight: bold;">1. วิธีการโอน</header>
        </div>
        <hr />
        <el-select
          style="width: 100%;"
          ref="transferMethods"
          placeholder="เลือกวิธีการโอน"
          v-model="transferId"
        >
          <el-option
            v-for="item in transferMethods"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
        <user-list
          v-model="users"
          :canSelectOneUser="true"
          :isFilterTokenxUser="true"
          :transferId="transferId"
        ></user-list>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
        <div>
          <header style="font-weight: bold;">3. แคมเปญ</header>
        </div>
        <hr />
        <el-select
          style="width: 100%;"
          ref="campaigns"
          placeholder="เลือกแคมเปญ"
          clearable
          v-model="campaignId"
          :disabled="!transferId || !isCampaignEarn()"
        >
          <el-option
            v-for="item in campaigns"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
        <header style="font-weight: bold;">4. เลือกกระเป๋าในการ transfer</header>
        <div class="mt-3">
          <div v-for="wallet in walletDropdown" :key="wallet.token_x_type">
            <label class="select-input" :class="!transferId ? 'disabled' : ''">
              <span>{{ wallet.token_x_type }}</span>
              <input
                type="radio"
                :value="wallet.token_x_type"
                name="wallet"
                v-model="walletSelect"
                :disabled="!transferId"
              />
              <span class="checkmark radio" :class="!transferId ? 'disabled' : ''"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
        <header style="font-weight: bold;">5. จำนวน Coin ที่ต้องการโอน</header>
        <hr />
        <el-input
          type="number"
          placeholder="ทศนิยมได้แค่ 2 ตำแหน่ง"
          v-model="coinAmount"
          :disabled="!transferId"
        ></el-input>
        <div class="mt-4">
          <header style="font-weight: bold;">หมายเหตุ
            <div class="optional" style="font-weight: normal;">(optional)</div>
          </header>
        </div>
        <hr />
        <el-input
          type="textarea"
          v-model="note"
          :disabled="!transferId" />
      </div>
      <div style="width: 100%; text-align: end; margin-right: 16px;">
        <sc-button v-bind:disabled="isViewOnlyByRole" variant="primary" @click="handleSubmit">บันทึก</sc-button>
      </div>
    </div>
  </div>
</template>

<script>
import UserList from "../../managements/modules/messaging/components/UserList";
import { Input } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import {
  formatDecimal,
  roundToTwoAndMultiplyOneHundred,
} from "@/lib/formatter";

export default {
  components: {
    "user-list": UserList,
    "el-input": Input,
    "sc-button": ScButton,
  },
  data() {
    const permission = JSON.parse(localStorage.getItem("adminRolePermission")) || null;

    return {
      users: [],
      coinAmount: null,
      note: null,
      walletDropdown: [],
      walletSelect: null,
      permission,
      transferMethods: [
        { id: 1, name: "โอนตรงให้ลูกค้า" },
        { id: 2, name: "โอนผูกแคมเปญ" },
      ],
      transferId: null,
      campaigns: [],
      campaignId: null
    };
  },
  async created() {
    await this.setupCampaignList();
    await this.setupWallet();
    this.focusTransferMethodsInput();
  },
  computed: {
    isViewOnlyByRole() {
      const roles = ['CC']
      return roles.includes(this.permission.role)
    }
  },
  methods: {
    async handleSubmit() {
      if (!this.transferId) {
        alert("กรุณาเลือกวิธีการโอน");
        return;
      }

      if (!this.users || this.users.length === 0) {
        alert("กรุณาเลือกลูกบ้าน");
        return;
      }

      if (this.transferId && this.isCampaignEarn() && !this.campaignId) {
        alert("กรุณาเลือกแคมเปญ");
        return;
      }

      if (!this.walletSelect) {
        alert("กรุณาเลือก กระเป๋า ในการ transfer");
        return;
      }

      if (!this.coinAmount || this.coinAmount.length === 0) {
        alert("กรุณากรอกจำนวน MNC ที่ต้องการโอนให้ลูกบ้าน");
        return;
      }

      try {
        const amount = formatDecimal(parseFloat(this.coinAmount));

        if (
          !confirm(
            `ต้องการโอน MNC ให้คุณ "${this.users[0].name} ${amount}coin"`
          )
        ) {
          return;
        }

        const earnCampaignId = this.isCampaignEarn() && this.campaignId
          ? this.campaignId
          : undefined;

        const earnCampaignName = earnCampaignId ?
          this.campaigns.find(campaign => campaign.id === earnCampaignId).name :
          undefined;

        const params = {
          user_id: this.users[0].id.toString(),
          amount: roundToTwoAndMultiplyOneHundred(amount),
          note: this.note || undefined,
          wallet_name: this.walletSelect,
          earn_campaign_id: earnCampaignId,
          earn_campaign_name: earnCampaignName
        };

        await baanRueJaiClient.admin.tokenx.send(params);

        alert("โอนเงินเข้าลูกบ้านเรียบร้อบ");
        this.clearSetupData();

        window.location.reload();
      } catch (error) {
        console.error(error)
        alert("ไม่สามารถโอนเงินเข้าลูกบ้านได้");
        return;
      }
    },
    clearSetupData() {
      this.transferId = null;
      this.users = [];
      this.coinAmount = null;
      this.note = null;
      this.walletSelect = null;
      this.campaignId = null;
    },
    async setupWallet() {
      this.walletDropdown =
        await baanRueJaiClient.admin.tokenx.getOrganizationWalletAdminCanTransferList();
      this.walletSelect = this.walletDropdown
        && this.walletDropdown[0]
        && this.walletDropdown[0].token_x_type
        ? this.walletDropdown[0].token_x_type
        : null;
    },
    async setupCampaignList() {
      this.campaigns = await baanRueJaiClient.admin.tokenx.getAllEarnCampaignList();
    },
    focusTransferMethodsInput() {
      this.$refs.transferMethods.focus();
    },
    isCampaignEarn() {
      return this.transferId === 2;
    }
  },
  watch: {
    transferId(val) {
      if (val) {
        this.$refs.transferMethods.blur();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.earn {
  padding: 15px;
}

.header {
  font-size: 16px;
  font-weight: normal;
}

.optional {
  font-size: 14px;
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/features/morning-coin/component/WalletToEarnUser.vue